<div class="qt-window">
  <header
    class="qt-window__header"
    cdkDragHandle
    [class.qt-window__header--max]="maximized()">
    <div class="qt-window__title">{{ data.title }}</div>
    <div class="qt-window__actions">
      <button
        mat-icon-button
        (click)="toggleMinimize()"
        [matTooltip]="
          minimized()
            ? ('GNR_RESTORE' | translate)
            : ('GNR_MINIMIZE' | translate)
        "
        [attr.aria-label]="
          minimized()
            ? ('GNR_RESTORE' | translate)
            : ('GNR_MINIMIZE' | translate)
        ">
        <mat-icon>
          {{ minimized() ? 'unfold_more' : 'expand_more' }}
        </mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="toggleMax()"
        [matTooltip]="
          maximized()
            ? ('GNR_RESTORE' | translate)
            : ('GNR_MAXIMIZE' | translate)
        "
        [attr.aria-label]="
          maximized()
            ? ('GNR_RESTORE' | translate)
            : ('GNR_MAXIMIZE' | translate)
        ">
        <mat-icon>
          {{ maximized() ? 'close_fullscreen' : 'open_in_full' }}
        </mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="close()"
        [matTooltip]="'CMD_CLOSE' | translate"
        [attr.aria-label]="'CMD_CLOSE' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <section class="qt-window__body">
    <qt-ai-chat [windowId]="data.id"></qt-ai-chat>
  </section>
</div>
